import moment from 'moment'

export function getDaysOfMonth(year, month) {
  if (month === 3 || month === 5 || month === 8 || month === 10) {
    return 30
  }

  if (month === 1) {
    if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
      return 29
    } else {
      return 28
    }
  }

  return 31
}

export function formatDate(value, partten = 'YYYY-MM-DD HH:mm:ss') {
  if (value === null || value === '') return '/'
  return moment(value).format(partten)
}

export function subtract(
  value,
  num,
  unit = 'days',
  partten = 'YYYY-MM-DD HH:mm:ss'
) {
  return moment(value)
    .subtract(num, unit)
    .format(partten)
}

export function add(
  value,
  num,
  unit = 'days',
  partten = 'YYYY-MM-DD HH:mm:ss'
) {
  return moment(value)
    .add(num, unit)
    .format(partten)
}

export function weekBegin(partten = 'YYYY-MM-DD') {
  const b1 = moment().startOf('month')
  const b2 = moment().startOf('week')
  const ret = b1.isAfter(b2) ? b1 : b2

  return ret.format(partten)
}

export function yearBegin(partten = 'YYYY-MM-DD') {
  return moment().startOf('year').format(partten)
}

export default {
  formatDate,
  subtract,
  weekBegin
}
